import style from './Notificator.module.scss'

interface IProps {
    value: string
}

export const Notificator = (props: IProps) => (
    <div className={style.container}>
        <span>{props.value}</span>
    </div>
)
